var map = {
	"./among/image.png": "2539",
	"./chill/image.png": "af1b",
	"./creepy/image.png": "afdc",
	"./doge/image.png": "49d8",
	"./frog/image.png": "3fd0",
	"./heycatch/image.png": "2420",
	"./ninja/image.png": "bf23",
	"./sneaky/image.png": "813d",
	"./surf/image.png": "858b",
	"./wake/image.png": "fdb5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f825";